//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"AnisotropicExponent",1,0],[0,"AnisotropicRule",1,0],[0,"CategoryStr",1,0],[0,"InitStrain",1,0],[0,"LankFordR00",1,0],[0,"LankFordR45",1,0],[0,"LankFordR90",1,0],[0,"MassDensity",1,0],[0,"MatCountryName",1,0],[0,"MatNameStr",1,0],[0,"MatTypeStr",1,0],[0,"MaterialParmK",1,0],[0,"MaterialParmN",1,0],[0,"PoissonRatio",1,0],[0,"RollAngle",1,0],[0,"ShearStrength",1,0],[0,"TensileStrength",1,0],[0,"YieldStress",1,0],[0,"YoungsModullus",1,0]],[],[]];
SPLM.Tooling.FormingMaterialLibraryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FormingMaterialLibraryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FormingMaterialLibraryBuilder.AniRule = Object.freeze({
    "Hill1948" : "Hill1948", "Bara1989" : "Bara1989", "Bara1991" : "Bara1991"});

export default SPLM;